
import { vertexFormat } from '../../../mixins/mixinProps'
import mixinGeometry from '../../../mixins/primitives/mixinGeometry'
export default {
  name: 'vc-geometry-plane',
  mixins: [vertexFormat, mixinGeometry]
}
